import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './PageSubTitle.module.css';

export type Props = {
  id?: string;
  className?: string;
  variant?: 'old' | 'new';
  onClick?: () => void;
  children: ReactNode;
};
export function PageSubTitle({ id, className, variant = 'old', onClick, children }: Props) {
  return (
    <span id={id} onClick={onClick} className={cx(className, styles[variant], styles.subTitle)}>
      {children}
    </span>
  );
}
